import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link, useHistory, useLocation } from "react-router-dom";
import { routeList, ROUTE_LOGIN, ROUTE_ADMINS_MENU, ROUTE_PANEL } from '../routes/routesConstants';

import alphabet from "../../images/alphabet_logo.svg";
import pauta from "../../images/pautaLogo.png"

import S4F_Logo from "../../images/S4F/logo.svg";

import { Button } from '@material-ui/core';
import { useState } from 'react';
import { RentalMenu } from './RentalMenu';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import { FactoryStatusAlert } from '../common/FactoryStatusAlert';
import { AdminMenu } from './AdminMenu';
import { isUserInRoles } from '../../commonFunctions/commonFunctions';
import { ADMIN_BOSCH, ADMIN, MANAGER } from '../../Constantes/userRoles';
import { useSelector } from 'react-redux';
import { selectUserRoles } from '../../redux/authentication/selectors';
import { ComprasSubMenu } from './ComprasSubMenu';
import { FinanciamentoSubMenu } from './FinanciamentoSubMenu';
import { SegurosSubMenu } from './SegurosSubMenu';

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: "100vw"
  },
  tab: {
    textTransform: 'none',
    minWidth: 20,
    backgroundColor: "#3B5158",
    fontSize: "0.9125rem",
    marginRight: 0,
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:hover': {
      color: '#40a9ff',
      opacity: 1,
    },
    '&$selected': {
      color: '#1890ff',
      fontWeight: theme.typography.fontWeightMedium,
    },
    '&:focus': {
      color: '#40a9ff',

    },
  },
  buttonLink: {
    color: "#3B5158",
    textTransform: 'none',
    /* fontWeight: "650", */
    fontSize: "0.9125rem",
  },
  button: {
    backgroundColor: "#ED2024",
    boxShadow: "none",
    borderRadius: "25px",
    textTransform: 'none',
    color: "white",
    '&:hover': {
      backgroundColor: '#FBBA00',
      boxShadow: "none",
    },
    marginRight: "25px",
    marginLeft: "25px",
    fontWeight: theme.typography.fontWeightMedium,
    fontSize: "0.9125rem",
  }
}));

const tabLabels = ["Dashboard", "Painel", "Casos", "Campañas", "Talleres", "Flotas", "Clientes", "ITV"];

export default function CenteredTabs() {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const [value, setValue] = React.useState(false);
  const [openRentalMenu, setOpenRentalMenu] = useState(false);
  const [openComprasMenu, setOpenComprasMenu] = useState(false);
  const [openFinanciamentoMenu, setOpenFinanciamentoMenu] = useState(false);
  const [openSegurosMenu, setOpenSegurosMenu] = useState(false);
  const [openAdminMenu, setOpenAdminMenu] = useState(false);
  const [showBar, setShowbar] = useState(true);
  const rentalAnchorRef = React.useRef(null);
  const comprasAnchorRef = React.useRef(null);
  const financiamentoAnchorRef = React.useRef(null);
  const segurosAnchorRef = React.useRef(null);
  const adminAnchorRef = React.useRef(null);
  const userRoles = useSelector(selectUserRoles)

  const handleChange = (event, newValue) => {
      setValue(newValue);
  };

  function handleLogout(){
    localStorage.removeItem('apoloCMRTK');
    history.push(ROUTE_PANEL);
  }

  function handleMenuClick(url){
    setValue(false);
    history.push(url)
  }

  useEffect(() => {
    let url = window.location.href
    routeList.map((item, i) => {
      if (url.includes(item.path) && !url.includes(ROUTE_ADMINS_MENU)) {
        setValue(item.label);
      }
    });
  },[window.location.href]);

  useEffect(() => {
    if (location.pathname === ROUTE_LOGIN) {
      setShowbar(false)
    } else { setShowbar(true) }
  }, [location])

  return (
    <div className={classes.root}>
      {showBar ? <nav className="main-navbar">
        <div style={{ marginTop: 5, marginLeft: 15, flexGrow: 1, cursor: "pointer" }} onClick={(e) => history.push(ROUTE_PANEL)}>
          <img src={S4F_Logo} width={"185px"} alt="" />    
        </div>
        {/* <div style={{margin: 5}}>
          <FactoryStatusAlert/>
        </div> */}
        { isUserInRoles([ADMIN, MANAGER], userRoles) &&
        <div style = {{height: "48px", backgroundColor: "#3B5158"}}>
          <Button endIcon = { openAdminMenu ? <ArrowDropDownIcon/> : <ArrowRightIcon/> } size="small" ref = {adminAnchorRef} 
            onClick={ () => setOpenAdminMenu(!openAdminMenu) } classes = {{ root: classes.buttonLink }} aria-controls = { openRentalMenu ? 'menu-list-grow' : undefined }
            aria-haspopup="true" style={{height: "100%", color: "white", paddingLeft: "15px"}} > Admin
          </Button>
        </div>
        }
        <AdminMenu open = {openAdminMenu} handleClose={setOpenAdminMenu} anchor={adminAnchorRef} handleMenuClick = {handleMenuClick}/>
        <div>
          <Tabs
            value={value}
            onChange={handleChange}
            indicatorColor="primary"
            textColor="primary"
            TabIndicatorProps={{ style: { backgroundColor: "transparent" } }}>
            {routeList.filter((route, i) => isUserInRoles(route.allowedRoles, userRoles)).map((route, i) => <Tab classes={{ root: classes.tab }} disableRipple label={route.label} component={Link} value={route.label} to={route.path} key={`tabnav-${route.label}`} />)}
          </Tabs>
        </div>
        {/* <div id="external-links" style={{ display: "flex" }}>        
          <Button size="small" href={"https://bosch.com/"} target="_new" classes={{ root: classes.buttonLink }}>Compras</Button>
          <Button size="small" href={"https://bosch.com/"} target="_blank" classes={{ root: classes.buttonLink }}>Financiamento</Button>
          <Button size="small" href={"https://bosch.com/"} target="_new" classes={{ root: classes.buttonLink }}>Seguros</Button> */}

        {/* <Button endIcon={openComprasMenu? <ArrowDropDownIcon/> : <ArrowRightIcon/> } size="small" ref={comprasAnchorRef} 
            onClick={ () => setOpenComprasMenu(!openComprasMenu) } classes = {{ root: classes.buttonLink }} aria-controls = { openComprasMenu ? 'menu-list-grow' : undefined }
            aria-haspopup="true"> Compras
          </Button>

          <Button endIcon={openFinanciamentoMenu? <ArrowDropDownIcon/> : <ArrowRightIcon/> } size="small" ref={financiamentoAnchorRef} 
            onClick={ () => setOpenFinanciamentoMenu(!openFinanciamentoMenu) } classes = {{ root: classes.buttonLink }} aria-controls = { openFinanciamentoMenu ? 'menu-list-grow' : undefined }
            aria-haspopup="true"> Financiamento
          </Button>

          <Button endIcon={openSegurosMenu? <ArrowDropDownIcon/> : <ArrowRightIcon/> } size="small" ref={segurosAnchorRef} 
            onClick={ () => setOpenSegurosMenu(!openSegurosMenu) } classes = {{ root: classes.buttonLink }} aria-controls = { openSegurosMenu ? 'menu-list-grow' : undefined }
            aria-haspopup="true"> Seguros
          </Button>
        </div> */}
        <Button size="small" onClick={ () => handleLogout() } classes = {{ root: classes.buttonLink }} > Sair</Button>
        {/* <ComprasSubMenu open={openComprasMenu} handleClose={setOpenComprasMenu} anchor={comprasAnchorRef}/>
        <FinanciamentoSubMenu open={openFinanciamentoMenu} handleClose={setOpenFinanciamentoMenu} anchor={financiamentoAnchorRef}/>
        <SegurosSubMenu open={openSegurosMenu} handleClose={setOpenSegurosMenu} anchor={segurosAnchorRef}/> */}
        {/* <RentalMenu open={openRentalMenu} handleClose={setOpenRentalMenu} anchor={rentalAnchorRef}/> */}
      </nav> : null}
    </div>
  );
}